import { Directive, TemplateRef, ViewContainerRef } from '@angular/core';
import { LoggedInUserService } from 'src/app/core/services/logged-in-user.service';

@Directive({
    selector: '[ifSuperAdminGeneralManager]'
})
export class IfSuperAdminGeneralManagerDirective {
    constructor(
        private readonly userService: LoggedInUserService,
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef
    ) {
        if (this.userService.isSuperAdmin()||this.userService.isGeneralManager()) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
}
